import { ReportDashboardComponentViewData, VisualizationType } from '@core/reports-types';
import { SortValue } from '@core/search-types';

import { isColumnSortPrimary } from './is-primary-sort';
import {
  getComponentVisualizationType,
  GetComponentVisualizationTypeInput,
} from './visualization-type';

export const reportComponentSortUpdate = (
  component: GetComponentVisualizationTypeInput &
    Pick<ReportDashboardComponentViewData, 'settings'>,
  sortChange: SortValue,
): Partial<Pick<ReportDashboardComponentViewData, 'sortBy' | 'sortOrder' | 'settings'>> => {
  const viewType = getComponentVisualizationType(component);

  return isColumnSortPrimary(component, sortChange.columnId)
    ? {
        sortBy: sortChange.columnId,
        sortOrder: sortChange.direction,
        ...(viewType !== VisualizationType.PivotTable && {
          settings: {
            ...component.settings,
            localSortBy: null,
            localSortOrder: null,
          },
        }),
      }
    : {
        settings: {
          ...component.settings,
          localSortBy: sortChange.columnId,
          localSortOrder: sortChange.direction,
        },
      };
};
